var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-page-title-component app-flex-column"},[_c('h2',{staticClass:"font-36 title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"font-18"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }